export const ACTIONS = {
  EVENT_EMAIL_HISTORY_FETCH_START: 'EVENT_EMAIL_HISTORY_FETCH_START',
  EVENT_EMAIL_HISTORY_FETCH_SUCCESS: 'EVENT_EMAIL_HISTORY_FETCH_SUCCESS',
  EVENT_EMAIL_HISTORY_FETCH_FAILURE: 'EVENT_EMAIL_HISTORY_FETCH_FAILURE',

  EVENT_EMAIL_HISTORY_SEND_START: 'EVENT_EMAIL_HISTORY_SEND_START',
  EVENT_EMAIL_HISTORY_SEND_SUCCESS: 'EVENT_EMAIL_HISTORY_SEND_SUCCESS',
  EVENT_EMAIL_HISTORY_SEND_FAILURE: 'EVENT_EMAIL_HISTORY_SEND_FAILURE',
};
